import React, { Component } from 'react'
import { Link } from 'react-router-dom'
import config from '../../config/config'
import { getToken, isSentry } from '../../lib'
import moment from 'moment'
import Paper from 'material-ui/Paper'
import PageView from 'material-ui/svg-icons/action/pageview'
import { Table, TableBody, TableHeader, TableHeaderColumn, TableRow, TableRowColumn } from 'material-ui/Table'

class Domain extends Component {
  constructor (props) {
    super(props)
    this.state = {
      domains: null,
      domainName: `/domain`
    }
  }

  Filter = (APIurl) => {
    const token = getToken()
    return fetch(`${APIurl}`, {
      method: 'GET',
      headers: {
        'Authenticity-Token': token,
        'Content-Type': 'application/json'
      }
    })
      .then((temp) => temp.json())
      .then(res => {
        if (res.status && res.status === 'success') {
          if (res.data === 'use admin') {
            alert('管理者アカウントを使ってください。')
            window.location = '/'
          } else {
            this.setState({domains: res.data.domains})
          }
        }
      })
      .catch((error) => {
        alert('サーバーとの接続にエラーが発生しました。')
        isSentry(error)
      })
  }

  componentDidMount () {
    const APIurl = `${config.URI}/api/v1/domains`
    this.Filter(APIurl)
  }

  render () {
    let domainRoute = this.state.domainName
    return (
      <div className="pl3 h-100" style={{color: '#6B7C93'}}>
        <div>
          <Paper style={{borderRight: '2px solid #e3e3e3', height: '85vh', padding: null}}>
            <Table selectable={false} selectedColor="black" height={'70vh'}>
              <TableHeader displaySelectAll={false} adjustForCheckbox={false}>
                <TableRow>
                  <TableHeaderColumn>会社名(name)</TableHeaderColumn>
                  <TableHeaderColumn>契約状態(contract status)</TableHeaderColumn>
                  <TableHeaderColumn>ステータス(domain status)</TableHeaderColumn>
                  <TableHeaderColumn>有効期限(expiration Date)</TableHeaderColumn>
                  <TableHeaderColumn>アクション(action)</TableHeaderColumn>
                </TableRow>
              </TableHeader>
              <TableBody deselectOnClickaway={false} displayRowCheckbox={false}>
                {this.state.domains && this.state.domains.map((val, index) => (
                  <TableRow key={index} selected={false} style={{backgroundColor: '#f2f3f6'}}>
                    <TableRowColumn style={{fontSize: 14, color: '#6B7C93'}}>{val.name}</TableRowColumn>
                    <TableRowColumn style={{
                      fontSize: 14,
                      color: '#6B7C93'
                    }}>{(val.trial) ? 'トライアル(Trial)' : '本契約(Payed Users)'} </TableRowColumn>
                    <TableRowColumn style={{fontSize: 14, color: '#6B7C93'}}>
                      {val.status === 'expire' ? <null>{val.expire_flag ? '無効(invalid)' : '有効(valid)'} </null> : null}
                      {val.status === 'valid' && '有効(valid)'}
                      {val.status === 'invalid' && '無効(invalid)'}</TableRowColumn>
                    <TableRowColumn style={{
                      fontSize: 14,
                      color: '#6B7C93'
                    }}>{(val.status === 'expire') ? moment(val.expire).format('YYYY-MM-DD') : ''}</TableRowColumn>
                    <TableRowColumn style={{fontSize: 14, color: '#6B7C93'}}><Link to={`${domainRoute}/${val.id}`}>{
                      <PageView color={'#000000de'}/>}</Link></TableRowColumn>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </Paper>
        </div>
      </div>
    )
  }
}

export default Domain



// WEBPACK FOOTER //
// ./src/routes/Domain/index.js